import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { usePoliciesQuery } from "../api/queries";
import { DocumentPortalTour } from "../tour/DocumentPortalTour";
import { policiesTourSteps } from "../tour/documentPortalTourSteps";
import { useDocumentPortalTour } from "../tour/useDocumentPortalTour";
import { PolicyDocumentCard } from "../ui/PolicyDocumentCard";

export function CompanyPoliciesPage() {
  const navigate = useNavigate();
  const tour = useDocumentPortalTour("doc-policies-tour-completed");
  const query = usePoliciesQuery();
  const data = query.data?.data ?? [];

  return (
    <>
      <Header />
      <Main>
        <div className="mb-8 flex justify-between space-y-4">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-bold text-2xl tracking-tight">ນະໂຍບາຍບໍລິສັດ</h1>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="size-8"
                onClick={tour.startTour}
              >
                <HelpCircle className="size-4" />
              </Button>
            </div>
            <p className="mt-0.5 font-medium text-muted-foreground">
              ອ່ານນະໂຍບາຍແລະລະບຽບທີ່ເຜີຍແຜ່ໃຫ້ພະນັກງານ
            </p>
            <div className="mt-2 h-1 w-16 rounded-full bg-muted-foreground" />
          </div>
          <div>
            <Button
              variant="default"
              className="w-full border-black font-medium hover:bg-black hover:text-white"
              onClick={() => navigate({ to: "/app/dashboard" })}
            >
              <ArrowLeft className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <div
          data-tourid="doc-policies-grid"
          className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
        >
          {query.isLoading ? (
            <>
              {Array.from({ length: 6 }, (_, i) => `skeleton-policy-${i}`).map(
                (key) => (
                  <div
                    key={key}
                    className="h-52 animate-pulse rounded-xl bg-muted"
                  />
                ),
              )}
            </>
          ) : data.length === 0 ? (
            <div className="col-span-full rounded-xl border-2 border-border border-dashed bg-muted/20 p-12 text-center">
              <p className="text-muted-foreground">ບໍ່ມີນະໂຍບາຍທີ່ເຜີຍແຜ່ໃຫ້ພະນັກງານ</p>
            </div>
          ) : (
            data.map((item) => (
              <PolicyDocumentCard
                key={item.id}
                item={item}
                onView={(policyId) =>
                  navigate({
                    to: "/app/documents/policies/$id",
                    params: { id: policyId },
                  })
                }
              />
            ))
          )}
        </div>
        <DocumentPortalTour
          steps={policiesTourSteps}
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
      </Main>
    </>
  );
}
